import { useAtomValue } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

type KeyboardLayout = 'fr-BE' | 'fr-FR' | 'en-US';

const LAYOUT_TO_SHORTCUTS: Record<
  KeyboardLayout,
  Record<'navigation' | 'actions' | 'search', string>
> = {
  'fr-BE': {
    search: ';',
    actions: ':',
    navigation: '=',
  },
  'fr-FR': {
    search: ';',
    actions: ':',
    navigation: '!',
  },
  'en-US': {
    search: ',',
    actions: '.',
    navigation: '/',
  },
};

export const KEYBOARD_LAYOUTS = [
  {
    value: 'fr-BE',
    label: 'Français (BE)',
  },
  {
    value: 'fr-FR',
    label: 'Français (FR)',
  },
  {
    value: 'en-US',
    label: 'English (US)',
  },
] as const;

export const KeyboardLayoutAtom = atomWithStorage<KeyboardLayout>('keyboardLayout', 'fr-BE');

export function useGetShortcutKeys() {
  const keyboardLayout = useAtomValue(KeyboardLayoutAtom);

  return LAYOUT_TO_SHORTCUTS[keyboardLayout];
}
